import FormService from "../../services/FormService";
import FormInput from '../../components/FormInput';
import SelectPicker from '../../components/SelectPicker';
import Pagination from "../../components/Pagination";

export default {
	components: {
		FormInput,
		SelectPicker,
        Pagination
	},
	data(){
		return {
			form: new FormService({
				name: null,
				price_per_km: null,
				status: null,
			}),
			modelList: [],
			modelStatus: [
				{
					"code": 5,
					"name": "Выключено",
				},
				{
					"code": 10,
					"name": "Включено",
				},
			],
			status: 0,
			searchStatus: '',
			searchStation: null,
            links: {},
            page: 1
		}
	},
	methods: {
		Create() {

			this.form.post('tariff.create')
				.then(res => {
					if (!res.errors) {
						$('#exampleModal').modal('hide');
						this.GetAll();
						this.$store.commit('successNotify');
					}
				});
		},
		Read(id) {
			this.$api.get('tariff.show', id)
				.then(res => {
					// console.log(res.data);
					this.form.setData(res.data);
					$('#exampleModal').modal('show');
				});
		},
		Update() {
			this.form.put('tariff.update', this.form.id)
				.then(res => {
					if (!res.errors) {
						$('#exampleModal').modal('hide');
						this.GetAll();
						this.$store.commit('successChangeNotify');
					}
				});
		},
		Delete(id) {
			if (confirm(this.i18n('You are about to delete the record!\nAre you sure?'))) {
				this.$api.delete('tariff.delete', id)
					.then(res => {
						if (!res.errors) {
							this.GetAll();
							this.$store.commit('successRemoveNotify');
						}
					});
			}
		},
		GetAll() {
			this.$api.get('tariff.index', {page: this.page, station: this.searchStation, status: this.searchStatus})
				.then(res => {
					this.modelList = res.data;
					this.links = res.links;
				});
		},
		filterTariffs() {
			this.page = 1;
			this.GetAll();
		}
	},
	mounted() {
		this.GetAll();
		$('#exampleModal').on('hidden.bs.modal', (e) => {
			this.form.reset();
		})
	},
    beforeRouteUpdate(to, from, next) {
        let page = to.params.page;
        if (page) {
            this.page = page;
            this.GetAll();
        }
        next();
    }
}
